module.exports = __webpack_public_path__ + "static/media/workingSchedule.4adfd500.png";